export const usersSchema = [
    {
        Header: 'Name',
        accessor: 'name',
        sortable: false,
        width: '20%',
        thClass: 'text-overflow'
    },
    {
        Header: 'Email',
        accessor: 'email',
        sortable: false,
        width: '40%',
        thClass: 'text-overflow'
    },
    {
        Header: 'Status',
        accessor: 'status',
        customCell: true,
        fieldType: 'status',
        sortable: false,
        width: '40%',
        thClass: 'text-overflow'
    },
    {
        Header: 'Actions',
        accessor: '',
        customCell: true,
        fieldType: 'columnActions',
        sortable: false,
        width: '15%',
        isEdit: true,
        isDelete: true
    }
];

export const dashboardSchema = [
    {
        Header: 'Member Name',
        accessor: 'fullName',
        sortable: false,
        width: '15%',
        thClass: 'text-overflow'
    },
    {
        Header: 'Gender',
        accessor: 'gender',
        sortable: false,
        width: '10%',
        thClass: 'text-overflow'
    },
    {
        Header: 'Phone Number',
        accessor: 'phoneNumber',
        sortable: false,
        width: '15%',
        thClass: 'text-overflow'
    },
    {
        Header: 'HCID',
        accessor: 'hcid',
        sortable: false,
        width: '10%',
        thClass: 'text-overflow'
    },
    {
        Header: 'Assessment Start Date ',
        accessor: 'assessmentStartDate',
        sortable: false,
        customCell: true,
        fieldType: 'date',
        toLocale: true,
        width: '10%',
        thClass: 'text-overflow'
    },
    // {
    //     Header: 'Inbound Call Date ',
    //     accessor: 'inboundCallDate',
    //     sortable: false,
    //     customCell: true,
    //     fieldType: 'date',
    //     toLocale: true,
    //     width: '10%',
    //     thClass: 'text-overflow'
    // },
    {
        Header: 'Assesment End Date ',
        accessor: 'assessmentEndDate',
        sortable: false,
        customCell: true,
        fieldType: 'date',
        toLocale: true,
        width: '10%',
        thClass: 'text-overflow'
    },
    {
        Header: 'Assesment Status',
        accessor: 'status',
        customCell: true,
        fieldType: 'status',
        sortable: false,
        width: '10%',
        thClass: 'text-overflow'
    },
    // {
    //     Header: 'Commercial Flag',
    //     accessor: 'commercialFlag',
    //     customCell: false,
    //     fieldType: 'commercialFlag',
    //     sortable: false,
    //     width: '10%',
    //     thClass: 'text-overflow'
    // },
    // {
    //     Header: 'Non-Commercial Flag',
    //     accessor: 'nonCommercialFlag',
    //     customCell: false,
    //     fieldType: 'nonCommercialFlag',
    //     sortable: false,
    //     width: '10%',
    //     thClass: 'text-overflow'
    // },
    {
        Header: 'Member Eligible',
        accessor: 'eligible',
        sortable: false,
        width: '10%',
        thClass: 'text-overflow'
    },
    {
        Header: 'Check Eligibility',
        accessor: 'needs',
        customCell: true,
        fieldType: 'checkEligibility',
        sortable: false,
        width: '10%',
        thClass: 'text-overflow'
    },
    {
        Header: 'Status',
        accessor: 'memberStatus',
        sortable: false,
        customCell: true,
        fieldType: 'memberStatus',
        width: '20%',
        thClass: 'text-overflow'
    },

    // {
    //     Header: 'Needs',
    //     accessor: 'needs',
    //     customCell: true,
    //     fieldType: 'viewNeeds',
    //     sortable: false,
    //     width: '10%',
    //     thClass: 'text-overflow'
    // },

    {
        Header: 'Actions',
        accessor: '',
        customCell: true,
        fieldType: 'customActions',
        sortable: false,
        width: '30%'
    }
];

export const needSchema = [
    {
        Header: 'Category',
        enableRowSpan: true,
        accessor: 'category',
        width: '12%',
        customCell: true,
        fieldType: 'category',
        classess: 'action-td p-0 position-relative'
    },
    {
        Header: 'Subcategory',
        enableRowSpan: true,
        accessor: 'subCategory',
        width: '13%',
        titleName: 'Goal',
        customCell: true,
        fieldType: 'subCategory',
        classess: 'action-td p-0 position-relative'
    },

    {
        Header: 'Goal',
        accessor: 'goal',
        customCell: true,
        sortable: false,
        width: '20%',
        classess: 'action-td position-relative'
    }
];
